@use '@/styles/variables' as *;

// ─── Layout ───────────────────────────────────────────────────────────────────

.work {
  width: 100%;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

// ─── Card ─────────────────────────────────────────────────────────────────────

.card {
  width: 100%;
  font: inherit;
  background: color-mix(in oklch, var(--card) 75%, transparent);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-soft);
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  opacity: 0;
  transform: translateY(28px);
  //cursor: pointer;
  text-align: left;
  transition:
    opacity 0.5s ease,
    transform 0.5s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;

  &:nth-child(2),
  &:nth-child(6) {
    transition-delay: 0.08s;
  }
  &:nth-child(3),
  &:nth-child(7) {
    transition-delay: 0.16s;
  }
  &:nth-child(4),
  &:nth-child(8) {
    transition-delay: 0.24s;
  }

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &:hover {
    transform: translateY(-3px);
    transition-delay: 0s;
    box-shadow: 0 20px 60px -20px color-mix(in oklch, var(--glow-forest) calc(var(--card-t) * 100%), var(--glow-water));
    border-color: color-mix(
      in srgb,
      color-mix(in oklch, var(--forest) calc(var(--card-t) * 100%), var(--water)) 30%,
      var(--border)
    );
  }

  &:focus-visible {
    outline: 2px solid var(--foreground);
    outline-offset: 3px;
  }
}

.cardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.cardTitle {
  font-size: 1.15rem;
  font-weight: 600;
  font-family: var(--font-display);
  color: var(--card-foreground);
  letter-spacing: -0.02em;
}

.demoLink {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--muted-foreground);
  font-size: 0.8rem;
  font-weight: 500;
  flex-shrink: 0;
  opacity: 0;
  transition:
    opacity 0.2s ease,
    color 0.2s ease;
}

.card:hover .demoLink {
  opacity: 1;
}

.description {
  font-size: 0.9rem;
  color: var(--muted-foreground);
  line-height: 1.65;
}

.contribution {
  font-size: 0.85rem;
  color: var(--forest);
  line-height: 1.55;
  font-style: italic;
  border-left: 2px solid var(--forest);
  padding-left: 0.75rem;
  margin-top: 0.25rem;
}

.stack {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: auto;
  padding-top: 0.5rem;
}

.tag {
  font-size: 0.75rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  background: var(--muted);
  color: var(--muted-foreground);
  font-weight: 500;
  letter-spacing: 0.02em;
}

// ─── Load more ────────────────────────────────────────────────────────────────

.loadMoreBtn {
  display: block;
  margin: 2rem auto 0;
  padding: 0.7rem 2rem;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--muted-foreground);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    border-color: var(--forest);
    color: var(--forest);
  }

  &:focus-visible {
    outline: 2px solid var(--foreground);
    outline-offset: 3px;
  }
}

// ─── Responsive ───────────────────────────────────────────────────────────────

@media (max-width: #{$breakpoint-sm}) {
  .grid {
    grid-template-columns: 1fr;
  }

  .demoLink {
    opacity: 1;
  }
}

// ─── Reduced motion ───────────────────────────────────────────────────────────

@media (prefers-reduced-motion: reduce) {
  .card {
    opacity: 1;
    transform: none;
    transition: box-shadow 0.25s ease;

    &:nth-child(n) {
      transition-delay: 0s;
    }
  }
}
